import { render, staticRenderFns } from "./BriefsOverview.vue?vue&type=template&id=c0625b62&scoped=true"
import script from "./BriefsOverview.vue?vue&type=script&lang=js"
export * from "./BriefsOverview.vue?vue&type=script&lang=js"
import style0 from "./BriefsOverview.vue?vue&type=style&index=0&id=c0625b62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0625b62",
  null
  
)

export default component.exports